'use client';

import { useTranslations } from 'next-intl';
import ServiceSection from './ServiceSection';
import {
  BoltIcon,
  DropletIcon,
  PlanIcon,
  CornerIcon,
  ShieldCheckIcon,
  DropletsIcon,
  RollerIcon,
  DecorIcon,
  LevelIcon,
  AwardIcon,
  FloorIcon,
  StairsIcon,
  DoorIcon,
} from '@/components/ui/icons/benefitIcons';
import { tileImages, tileVideos, paintingImages, floorsImages, electricalComparison, electricalImage } from '@/lib/media';

export default function Services() {
  const electrical = useTranslations('electrical');
  const tile = useTranslations('tile');
  const painting = useTranslations('painting');
  const floors = useTranslations('floors');

  return (
    <>
      {/* Electrical & Plumbing — before/after comparison slider + a standalone still */}
      <ServiceSection
        id="instalacje"
        stage={1}
        eyebrow={electrical('eyebrow')}
        headline={electrical('headline')}
        benefits={[
          { title: electrical('benefit1Title'), desc: electrical('benefit1Desc'), icon: BoltIcon },
          { title: electrical('benefit2Title'), desc: electrical('benefit2Desc'), icon: DropletIcon },
          { title: electrical('benefit3Title'), desc: electrical('benefit3Desc'), icon: PlanIcon },
        ]}
        comparison={{ left: electricalComparison.before, right: electricalComparison.after }}
        image={electricalImage}
        mediaPosition="right"
        tone="light"
      />

      {/* Tile Installation — 22 photos, lead image first */}
      <ServiceSection
        id="plytki"
        stage={2}
        eyebrow={tile('eyebrow')}
        headline={tile('headline')}
        benefits={[
          { title: tile('benefit1Title'), desc: tile('benefit1Desc'), icon: CornerIcon },
          { title: tile('benefit2Title'), desc: tile('benefit2Desc'), icon: ShieldCheckIcon },
          { title: tile('benefit3Title'), desc: tile('benefit3Desc'), icon: DropletsIcon },
        ]}
        dragGallery={tileImages}
        videos={tileVideos}
        mediaPosition="left"
        tone="dark"
      />

      {/* Painting & Decorative Finishes — 5 photos */}
      <ServiceSection
        id="malowanie"
        stage={3}
        eyebrow={painting('eyebrow')}
        headline={painting('headline')}
        benefits={[
          { title: painting('benefit1Title'), desc: painting('benefit1Desc'), icon: RollerIcon },
          { title: painting('benefit2Title'), desc: painting('benefit2Desc'), icon: DecorIcon },
          { title: painting('benefit3Title'), desc: painting('benefit3Desc'), icon: LevelIcon },
          { title: painting('benefit4Title'), desc: painting('benefit4Desc'), icon: AwardIcon },
        ]}
        gallery={paintingImages}
        mediaPosition="right"
        tone="light"
      />

      {/* Floors & Doors — two images (Doors + Floor) as an equal side-by-side pair */}
      <ServiceSection
        id="podlogi-drzwi"
        stage={4}
        eyebrow={floors('eyebrow')}
        headline={floors('headline')}
        benefits={[
          { title: floors('benefit1Title'), desc: floors('benefit1Desc'), icon: FloorIcon },
          { title: floors('benefit2Title'), desc: floors('benefit2Desc'), icon: StairsIcon },
          { title: floors('benefit3Title'), desc: floors('benefit3Desc'), icon: DoorIcon },
        ]}
        pairGallery={floorsImages}
        mediaPosition="left"
        tone="dark"
      />
    </>
  );
}
